export const SET_ACTIVE = 'SET_ACTIVE'
export const SET_OTHER_CITY_MODE = 'SET_OTHER_CITY_MODES'
export const SET_CITIES = 'SET_CITIES'
